var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"myGrid",attrs:{"gridConfigUrl":_vm.gridConfigUrl},scopedSlots:_vm._u([{key:"topSelectMenus",fn:function(props){return [_c('div',{staticClass:"main-table-txt",staticStyle:{"line-height":"40px","color":"gray"}},[_vm._v("备注：默认统计日期范围为近一个月")])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4c0f658","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/custom/components/grid/biz-stats-tip.vue
// module id = null
// module chunks = 